<div class="group-header">
  <div class="label-container">
    <app-markdown class="group-label" [class.focused]="isFocused" [rawMarkdown]="label"></app-markdown>
  </div>
  <span class="find-in-chat" (click)="onFindInChat()">
      <img [src]="'svg/expand.svg' | assetVersion" alt="find in chat">
    Find in chat</span>
</div>
